import ApplicationsForm from "./ApplicationsForm";

/**
 * Paraiskos korteles funcionalumas
 */
class ApplicationsReceiverCard {
    constructor(wizard, $card = null, subject_type = null, aid_type = null, subject = null) {
        this.wizard = wizard
        this.$form = null;
        this.$card = $card;

        this.subject_type = subject_type;
        this.aid_type = aid_type;

        if(!this.$card){
            let $receiversAccordion = this.wizard.$multiform.find('#receivers-accordion');
            var templateHtml = $receiversAccordion.find('template#receiver-card').html();

            // if(this.subject){
            //     templateHtml = templateHtml.replace(/\[user_code]/gi, this.subject.code);
            //     templateHtml = templateHtml.replace(/\[user_status]/gi, this.subject.status);
            //     templateHtml = templateHtml.replace(/\[user_name]/gi, this.subject.name);
            // }else{
            //     templateHtml = templateHtml.replace(/\[user_code]/gi, '');
            //     templateHtml = templateHtml.replace(/\[user_status]/gi, '');
            //     templateHtml = templateHtml.replace(/\[user_name]/gi, '');
            // }


            templateHtml = templateHtml.replace(/card_id/gi, this.wizard.uuidv4());


            this.$card = $(templateHtml);
            $receiversAccordion.append(this.$card);
        }
        this.$card.data('instance', this);

        //
        // if(subject){
        //     this.subject = subject;
        // }else if($card){
        //     this.item = $card.data('item')
        // }
        //
        this.init();
    }

    init(){

        var openCard = false;

        this.$card.find('button[data-card-remove]').on('click', function (e) {

            setTimeout(function () {
                if(!e.originalEvent.defaultPrevented){
                    this.removeCard();
                }
            }.bind(this), 100)

        }.bind(this));

        this.$card.find('button[data-card-clone]').on('click', function (e) {
            this.cloneCard();
        }.bind(this));

        this.$collapsable = this.$card.find('.collapsable');

        this.$collapsable.on('shown.bs.collapse', function () {
            if(this.hasForm()){
                this.initFormInputs();
                this.$form[0].conditional_instance.checkInputs();
            }
        }.bind(this))

        if(openCard){
            this.openCard();
        }
    }

    openCard(){
        this.$collapsable.collapse('show');
    }
    closeCard(){
        this.$collapsable.collapse('hide');
    }

    isOpen(){
        return this.$collapsable.hasClass('show');
    }

    removeCard(){
        this.$card.remove();
        this.wizard.invalidateLayout();
        this.wizard = null;
        this.$card = null;
    }
    cloneCard(){
        if(this.hasForm()){
            let card = new ApplicationsReceiverCard(this.wizard, null, this.subject_type, this.aid_type);
            var formData = this.$form.serialize();

            //pasalinam laukus, kuriu nereikia klonuoti
            //formData = formData.replace(/&(aid_receiver|foreign_code|foreign_type|foreign_name|foreign_company_vat|foreign_size|foreign_document_code)=[^&]*/gi, '');
            card.loadContent(formData)
        }

        // let $clone = this.$card.clone();
        // this.wizard.$multiform.find('#receivers-accordion').append($clone);
        //
        // card.loadContent('<p>aaa</p>')

    }
    scrollIntoView(delay){
        if(delay){
            setTimeout(function (){
                this.scrollIntoView()
            }.bind(this), delay)
        }
        this.$card[0].scrollIntoView();
    }

    loadContent(formData = null){
        var data = {
            guid: this.wizard.$multiform.data('guid')
        };

        if(this.aid_type){
            data.aid_type = this.aid_type;
        }
        if(this.subject_type){
            data.subject_type = this.subject_type;
        }

        if(formData){
            data.formData = formData
        }

        if(this.$card.data('item')){
            data.id = this.$card.data('item');
        }

        $.ajax(this.wizard.$multiform.closest('#applications-wizard-wrap').data('baseurl') + '/load_receiver_form', {
            data:data
        }).done(function (r) {
            let $content = $(r);
            this.setContent($content);
            this.scrollIntoView(300)

        }.bind(this)).fail(function (e) {
            this.$card.find('card-body').html('<p class="alert alert-danger">failed</p>');
        }.bind(this));
    }

    setContent($content){
        this.$card.find('.card-body').html($content);

        if($content.length && $content[0].tagName === 'FORM'){
            this.$form = $content;

            this.initFormInputs();

            this.updateFormBaseData()

            this.$form.on('before-submit', function (e, r) {
                this.showProgress();
            }.bind(this)).on('after-submit', function (e, r) {
                this.hideProgress();

                //setTimeout naudojam tam, kad after-submit iskvieciamas ansciau, negu ajax-form atlieka tolimesnius veiksmus
                setTimeout(function () {
                    this.afterFormSubmit(r);
                }.bind(this), 100);

            }.bind(this)).on('submit-fail', function () {
                this.setFormStatus('fail', 'danger');
                if(this.after_form_submit_callback){
                    this.after_form_submit_callback();
                    this.after_form_submit_callback = null;
                }
                this.wizard.invalidateLayout();
            }.bind(this))
            this.wizard.invalidateLayout();
            this.updateTitle();
        }
    }

    afterFormSubmit(response){
        let $inputs = this.wizard.$multiform.find('[data-baseform]').find('select,input');
        $inputs
            .removeClass('is-invalid is-valid')
            .parents('.form-group').find('.invalid-feedback').html('').removeClass('d-block')
        ;
        if(response.status === 'error'){
            $inputs.each(function (index, element) {
                if(response.errors[element.name]){
                    $(element)
                        .addClass('is-invalid')
                        .parents('.form-group')
                        .find('.invalid-feedback')
                        .html(response.errors[element.name])
                        .addClass('d-block')
                    ;
                }
            })
        }
        if(response.form_data_status){
            this.setFormStatus(response.form_data_status_name, response.form_data_status_style);
        }

        if(response.application_id){
            this.updateId(response.application_id);
        }

        if(this.after_form_submit_callback){
            this.after_form_submit_callback();
            this.after_form_submit_callback = null;
        }

        if(!this.hasForm()){
            this.$card.find('button[data-card-remove]').remove();
            this.$card.find('button[data-card-clone]')
                .off('click')
                .find('i').removeClass('far fa-clone').addClass('far fa-check-circle');

        }

        this.wizard.invalidateLayout();
    }

    updateTitle(){
        if(!this.hasForm()) return;

        if(this.$form.find('#user-code-table-aid_receiver').length){

            let $row = this.$form.find('#user-code-table-aid_receiver tr[data-user-code]');
            if($row.length){
                this.$card.find('.card-header [data-user-name]').html(
                    $row.find('[data-user-name]').html()
                );
                this.$card.find('.card-header [data-user-code]').html(
                    $row.find('[data-user-code]').html()
                );
                this.$card.find('.card-header [data-user-status]').html(
                    $row.find('[data-user-status]').html()
                );
            }else{
                this.$card.find('.card-header [data-user-name]').html('');
                this.$card.find('.card-header [data-user-code]').html('');
                this.$card.find('.card-header [data-user-status]').html('');
            }

        }else{
            if(this.$form.find('input[name="foreign_name"]').length){
                this.$card.find('.card-header [data-user-name]').html(
                    this.$form.find('input[name="foreign_name"]').val()
                );
            }
            if(this.$form.find('input[name="foreign_code"]').length){
                this.$card.find('.card-header [data-user-code]').html(
                    this.$form.find('input[name="foreign_code"]').val()
                );
            }
        }



    }

    hasForm(){
        if(this.$form && this.$form.parent().length === 0){
            this.$form = null;
        }
        return this.$form  !== null;
    }

    initFormInputs(){
        if(this.formInstance) return;
        if(!this.hasForm()) return;
        if(!this.isOpen()) return;





        //local user type
        this.$form.find("input[data-input_name='aid_receiver']").on('add-subject', function (e, subject) {
            this.updateTitle();
        }.bind(this)).on('remove-subject', function (e) {
            this.updateTitle();
        }.bind(this));

        //foreign user type
        this.$form.find('input[name="foreign_code"]').on('change', function (e) {
            this.updateTitle();
        }.bind(this));

        this.$form.find('input[name="foreign_name"]').on('change', function (e) {
            this.updateTitle();
        }.bind(this));

        //---------------------------------------

        this.formInstance = ApplicationsForm.init(this.$form)
    }


    validateForm(callback = null){
        if(!this.hasForm()) return;
        //this.$form.find('button[type="submit"][name="action"][value="validate"]').click();
        this.$form.trigger('submit', {action: 'validate'});
        this.after_form_submit_callback = callback;
    }
    submitForm(callback = null){
        if(!this.hasForm()) return;
        this.$form.trigger('submit', {action: 'submit'});
        this.after_form_submit_callback = callback;
    }
    draftForm(callback = null){
        if(!this.hasForm()) return;

        this.$form.trigger('submit', {action: 'draft'});
        this.after_form_submit_callback = callback;
    }

    updateFormBaseData(){
        if(!this.hasForm()) return;
        this.wizard.$multiform.find('[data-baseform]').find('input[type="radio"]:checked,select').each(function (index,input) {
            this.$form.find('input[name="'+input.name+'"]').val(
                input.value
            ).change();
        }.bind(this))
    }

    setFormStatus(status, style){
        this.$card.find('[data-form-status]')
            .html(status)
            .removeClass()
            .addClass('text-' + style)
        ;
    }
    hideProgress(){
        this.$card.find('[data-form-status]').html('');
    }
    showProgress(){
        this.$card.find('[data-form-status]').removeClass().html(
            '<div class="spinner-border spinner-border-sm" role="status"> <span class="sr-only">Loading...</span></div>'
        );
    }
    updateId(applicationId){
        if(!this.hasForm()) return;

        var $idInput = this.$form.find('input[name="id"]');
        if($idInput.length === 0){
            $idInput = $('<input type="hidden" name="id"/>')
            this.$form.append($idInput);
        }
        $idInput.val(applicationId)

    }


}



export default ApplicationsReceiverCard;